import { FieldsConfig } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { useApiScope } from '../scope';

/**
 * Fetches the global bank account fields config from the backend.
 * Result is cached globally by SWR — only one network request ever fires.
 */
export function useBankAccountFieldsConfig(): {
  config: FieldsConfig | null;
  isLoading: boolean;
  error: unknown;
} {
  const { shareToken } = useApiScope();

  const { data, error, isLoading } = useSWR<FieldsConfig>(
    'bankAccount/fields-config',
    SWRFetcher({ method: 'GET', shareToken }),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 60 * 60 * 1000, // cache for 1 hour — config changes rarely
      errorRetryCount: 2, // fail fast — don't retry forever
      shouldRetryOnError: true,
    }
  );

  return {
    config: data ?? null,
    isLoading,
    error,
  };
}
